"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgNode_1 = __importDefault(require("./SvgNode"));
const CLIPPABLE_SHAPES = {
    path: true,
    text: true,
    rect: true,
    circle: true,
    ellipse: true,
    polyline: true,
    line: true,
    polygon: true,
};
/*
 * Renders a path (usually a compound path) of a layer with the openings cut out (eg. a piece of
 * matboard which would be cut).
 */
function ClipPath({ id, nodeData = null }) {
    /*
     * An SVG clipPath element can only contain certain elements. So eliminate
     * any non-clippable elements flatten their children.
     */
    function getPathElements(rootNodeData) {
        function addNode(nodeData, accumulator) {
            if (nodeData.name in CLIPPABLE_SHAPES) {
                accumulator.push(nodeData);
            }
            else if (nodeData.children) {
                nodeData.children.forEach(childNodeData => addNode(childNodeData, accumulator));
            }
        }
        const clippable = [];
        addNode(rootNodeData, clippable);
        return clippable;
    }
    return (react_1.default.createElement("clipPath", { id: id }, getPathElements(nodeData).map((pathElement, i) => {
        return react_1.default.createElement(SvgNode_1.default, { key: i, nodeData: pathElement });
    })));
}
exports.default = ClipPath;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2xpcFBhdGguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tcG9uZW50cy9DbGlwUGF0aC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxrREFBMEI7QUFDMUIsd0RBQWdDO0FBR2hDLE1BQU0sZ0JBQWdCLEdBQUc7SUFDdkIsSUFBSSxFQUFFLElBQUk7SUFDVixJQUFJLEVBQUUsSUFBSTtJQUNWLElBQUksRUFBRSxJQUFJO0lBQ1YsTUFBTSxFQUFFLElBQUk7SUFDWixPQUFPLEVBQUUsSUFBSTtJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLElBQUk7SUFDVixPQUFPLEVBQUUsSUFBSTtDQUNkLENBQUM7QUFPRjs7O0dBR0c7QUFDSCxTQUF3QixRQUFRLENBQUMsRUFBRSxFQUFFLEVBQUUsUUFBUSxHQUFHLElBQUksRUFBUztJQUM3RDs7O09BR0c7SUFDSCxTQUFTLGVBQWUsQ0FBQyxZQUFZO1FBQ25DLFNBQVMsT0FBTyxDQUFDLFFBQVEsRUFBRSxXQUFXO1lBQ3BDLElBQUksUUFBUSxDQUFDLElBQUksSUFBSSxnQkFBZ0IsRUFBRTtnQkFDckMsV0FBVyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQzthQUM1QjtpQkFBTSxJQUFJLFFBQVEsQ0FBQyxRQUFRLEVBQUU7Z0JBQzVCLFFBQVEsQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQyxFQUFFLENBQ3hDLE9BQU8sQ0FBQyxhQUFhLEVBQUUsV0FBVyxDQUFDLENBQ3BDLENBQUM7YUFDSDtRQUNILENBQUM7UUFFRCxNQUFNLFNBQVMsR0FBRyxFQUFFLENBQUM7UUFDckIsT0FBTyxDQUFDLFlBQVksRUFBRSxTQUFTLENBQUMsQ0FBQztRQUNqQyxPQUFPLFNBQVMsQ0FBQztJQUNuQixDQUFDO0lBRUQsT0FBTyxDQUNMLDRDQUFVLEVBQUUsRUFBRSxFQUFFLElBQ2IsZUFBZSxDQUFDLFFBQVEsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLFdBQVcsRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUNoRCxPQUFPLDhCQUFDLGlCQUFPLElBQUMsR0FBRyxFQUFFLENBQUMsRUFBRSxRQUFRLEVBQUUsV0FBVyxHQUFJLENBQUM7SUFDcEQsQ0FBQyxDQUFDLENBQ08sQ0FDWixDQUFDO0FBQ0osQ0FBQztBQTVCRCwyQkE0QkMifQ==